<div class="service-provider-list-container">
  <h2>Service Providers for {{ service }}</h2>

  <div *ngIf="locationError" class="location-error">
    <p>{{ locationError }}</p>
    <button (click)="getLocation()">Retry</button>
  </div>

  <div class="service-provider-list">
    <div *ngFor="let provider of serviceProviders" class="service-provider-card">
      <a [routerLink]="['/service-provider-details', provider.nid]">
        <h3>{{ provider.field_name }}</h3>
        <p class="location">{{ provider.field_city }}, {{ provider.field_municipal_region }}</p>
        <p class="distance" *ngIf="provider.distance">{{ provider.distance }} km</p>
      </a>
    </div>
  </div>
</div>
